import React from 'react';
import PackBtn from './PackBtn'

const Card = ({ packDetails, goToNextStep, isBottom, hasThreePack }) => {
    const { title, subTitle, price, info, id } = packDetails;
    return (
      <div className={`card ${hasThreePack ? "three-packs" : ""}`}>
        <div className="cardText-container">
          <h4 className="cardText-title">{title}</h4>
          <h5 className="cardText-subtitle">{subTitle}</h5>
          <p className="cardText-price">
            { 
              price === 'Offerte'? (
                <span>{price}</span>
              ) : (
                <span>{price} <sup>HT</sup></span>
              )
            }
          </p>
          {info && <p className="cardText-info">{info}</p>}
        </div>
        <div className="card-footer">
          <PackBtn goToNextStep={() => goToNextStep(id, title)} isBottom={isBottom}/>
        </div>
      </div>
    );
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/buy/table-checkouts/PackSelectorPage/Details/Card.js